const TabNav = ({ id, title, activeTab, setActiveTab }) => {
	const handleTabClick = () => setActiveTab(id);

	return (
		<li onClick={handleTabClick} className={activeTab === id ? 'is-active' : ''} title={`Click to view ${title.toLowerCase()} weather`}>
			{title}
		</li>
	);
};

export default TabNav;
